import { render, staticRenderFns } from "./subscription-text.vue?vue&type=template&id=a1b6cc62&"
import script from "./subscription-text.vue?vue&type=script&lang=js&"
export * from "./subscription-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports